import React from 'react';
import Routing from './routes/Routing';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0F7F85',
      contrastText: '#fff',
    },
    secondary: {
      main: '#3D3D3D',
      contrastText: '#fff',
    },
    info: {
      main: '#9E9E9E',
      contrastText: '#fff',
    },
    warning: {
      main: '#AEAEAE',
      contrastText: '#fff',
    },
  },
  transitions: {
    duration: {
      enteringScreen: 500,
      leavingScreen: 500,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Routing />
      </div>
    </ThemeProvider>
  );
}

export default App;
